import React from 'react';
import { tddRoot } from "../../../../utils/defaultValues";
import IntlMessages from "../../../../utils/IntlMessages";
import KeyFindingsHome from './KeyFindingsHome';

const KeyFindingsHomeRouteConfig = {
	routes: [
    {
      path: `${tddRoot}/project/defects`,
      exact: true,
      name: <IntlMessages id={"menu.defects"}/>,
      element: <KeyFindingsHome/>,
      auth: [],
    },
    ]
};

export default KeyFindingsHomeRouteConfig;
